var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("bar-top", {
        attrs: {
          "drop-down-routes": _vm.dropDownRoutes,
          "current-route": _vm.currentRoute,
        },
        on: {
          preview: _vm.preview,
          genShell: _vm.writeShell,
          select: _vm.handleSelectRoute,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "main" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c("preview", {
              attrs: { url: _vm.currentSkeletonScreen.url, type: "origin" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "middle" },
          [
            _c("preview", {
              attrs: {
                url: _vm.currentSkeletonScreen.skeletonPageUrl,
                type: "skeleton",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c("edit", {
              attrs: {
                html: _vm.currentSkeletonScreen.html,
                "current-route": _vm.currentRoute,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "show-close": false,
            modal: true,
            width: "360px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [_vm._v("手机预览")]
          ),
          _vm._v(" "),
          _c("p", [_vm._v("1. 手机和开发电脑连入同一 WIFI 网络。")]),
          _vm._v(" "),
          _c("p", [_vm._v("2. 在系统「安全性与隐私」设置中，关闭防火墙。")]),
          _vm._v(" "),
          _c("p", [_vm._v("3. 打开微信「扫一扫」，扫描二维码。")]),
          _vm._v(" "),
          _c("div", { staticClass: "image-wrapper" }, [
            _c("img", {
              attrs: { src: _vm.currentSkeletonScreen.qrCode, alt: "qr code" },
            }),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }